import { Box, TextField } from "@mui/material";
import React, { useMemo, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState, setTotalValues } from "./defineSlice";
import './Define.css'
import {
	formatNumber,
	removeComma,
	isWeekColumnEditable,
	rowDepletionModelKey,
	shouldShowBlankWeekPlaceholder,
	findGridRowByCustomerSku,
	commitGridDataUpdate,
} from "./defineUtils";
import debounce from 'lodash/debounce';
import { QUOTA_CELL_DEBOUNCE_MS, useQuotaCellInputSync } from "./useQuotaCellInput";

export default function TableCellWeek3(params) {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const { gridData, gridDataFiltered, selectedDepletionPeriodType } = define;
   const gridDataRef = useRef(gridData);
   const gridDataFilteredRef = useRef(gridDataFiltered);
   gridDataRef.current = gridData;
   gridDataFilteredRef.current = gridDataFiltered;
   const rowDm = rowDepletionModelKey(params.row);
   const cellInput = useQuotaCellInputSync(params.row.weekly3);
   const { setDraft, displayValue, onFocus, onBlur } = cellInput;
   const customerID = params.row.customerID;
   const customerGroupID = params.row.customerGroupID;
   const productGroupID = params.row.productGroupID;
   const skuid = params.row.skuid;

   function updateGrid(hasError, w) {
      let updatedItem = null;
      const filtered = gridDataFilteredRef.current;
      const fullGrid = gridDataRef.current;
      const updated = filtered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if (flag === true) {
            updatedItem = {
               ...item,
               hasError,
               weekly3: !w ? 0 : w,
            };
            return updatedItem;
         }
         return item;
      });

      const updatedGrid = [];
      for (let i = 0; i < fullGrid.length; ++i) {
         const item = fullGrid[i];
         if(item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         }
         else {
            updatedGrid.push(item);
         }
      }
      commitGridDataUpdate(dispatch, setState, {
         gridData: updatedGrid,
         gridDataFiltered: updated,
         updatedRow: updatedItem,
         backupFields: ["weekly3"],
      });
   }


   // function updateWeek3(event) {
   //    let w3 = removeComma(event.target.value);
   //    w3 = Number(w3);
   //    let w2 = Number(params.row.weekly2);
   //    let w4 = Number(params.row.weekly4);
   //    let hasError = false;
   //    setWeek3(w3);
   //    if(!w3 && w3!==0) {
   //       dispatch(setState("isError", true));
   //       dispatch(setState("isError_Info", "Only numbers are allowed."));
   //       return;
   //    }

   //    if(w2 > w3) {
   //       hasError = true;
   //    }
   //    else if(w3 > w4) {
   //       hasError = true;
   //    }
   //    dispatch(setState("gridDataChanged", true));
   //    updateGrid(hasError, w3);
   //    dispatch(setTotalValues());
   // }

   const debouncedUpdate = useMemo(
      () =>
         debounce((hasError, w3) => {
            dispatch(setState("gridDataChanged", true));
            updateGrid(hasError, w3);
            dispatch(setTotalValues());
         }, QUOTA_CELL_DEBOUNCE_MS),
      [
         params.row?.customerID,
         params.row?.customerGroupID,
         params.row?.productGroupID,
         params.row?.skuid,
         params.row?.depletionModel,
         dispatch,
      ]
   );

   useEffect(() => {
      return () => debouncedUpdate.cancel();
   }, [debouncedUpdate]);

   function updateWeek3(event) {
      let raw = removeComma(event.target.value);
      setDraft(raw);
      let w3 = Number(raw);
      const live =
         findGridRowByCustomerSku(gridDataFilteredRef.current, params.row) ??
         findGridRowByCustomerSku(gridDataRef.current, params.row) ??
         params.row;
      const dmLive = rowDepletionModelKey(live);
      let w4 = Number(live.weekly4);
      let hasError = false;
      if(!w3 && w3!==0) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Only numbers are allowed."));
         return;
      }

      if (dmLive !== "none" && dmLive !== "biweekly" && w3 > w4) {
         hasError = true;
      }
      debouncedUpdate(hasError,w3);
   }

   function handleValidity(w2, w3, w4){
      if (rowDm === "none" || rowDm === "biweekly") {
         return;
      }
      if (Number(w3) > Number(w4)) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Must be less or equal to Week4"));
      }
   }

   if (shouldShowBlankWeekPlaceholder(3, params.row, gridDataFiltered)) {
      return <Box sx={{ width: 100 }} />;
   }

   return (
      <TextField
         variant="standard"
         disabled={
            !isWeekColumnEditable(
               3,
               params.row,
               selectedDepletionPeriodType
            )
         }
         value={displayValue}
         className={
            rowDm !== "none" &&
            rowDm !== "biweekly" &&
            Number(params.row.weekly3) > Number(params.row.weekly4)
               ? "red-row"
               : ""
         }
         onChange={updateWeek3}
         onFocus={onFocus}
         onBlur={() => {
            debouncedUpdate.flush();
            onBlur();
            handleValidity(params.row.weekly2, params.row.weekly3, params.row.weekly4);
         }}
         sx={{ width: 100 }}
      />
   );
}
